/* s1-pdp UGC reel (ugc_reel block): full-screen viewer for the poster tiles
   rendered by snippets/s1-pdp-ugc-reel.liquid.
   - Nothing loads until a tile is tapped; the viewer holds ONE <video> and
     swaps its src (prev / next), prefetching only the next clip.
   - Sound on by default inside the viewer (it opens from a tap, so browsers
     allow it); falls back to muted autoplay if the browser refuses.
   - Add to Cart in the viewer drives the page's main s1-pdp button
     ([data-s1-atc-btn]) and mirrors its label / disabled state; when the main
     button is disabled (no size picked) the viewer closes and scrolls to the
     size selector, like the kit's sticky bar.
   - Event delegation + a MutationObserver-free design: tiles are read at tap
     time, so the s1-pdp section re-rendering on a fit switch needs no rewire. */
(() => {
  if (window.__surInit) return;
  window.__surInit = true;

  const ICON = {
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    muted: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="m23 9-6 6M17 9l6 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor"><path d="M7 5.5v13a1 1 0 0 0 1.53.85l9.5-6.5a1 1 0 0 0 0-1.7l-9.5-6.5A1 1 0 0 0 7 5.5z"/></svg>',
  };

  let fs = null, video = null, els = {};
  let items = [], idx = 0, muted = false, prefetched = new Set();
  /* page videos we paused when the viewer opened (gallery loops, the science clip) */
  let pausedOthers = [];

  const mainBtn = () => document.querySelector('[data-s1-atc-btn]');

  function build() {
    if (fs) return;
    fs = document.createElement('div');
    fs.className = 'sur-fs';
    fs.hidden = true;
    fs.setAttribute('role', 'dialog');
    fs.setAttribute('aria-modal', 'true');
    fs.setAttribute('aria-label', 'Customer video');
    fs.innerHTML =
      '<div class="sur-fs__stage" data-sur-stage>' +
        '<video class="sur-fs__video" data-sur-video playsinline preload="auto"></video>' +
        '<span class="sur-fs__paused" data-sur-paused hidden>' + ICON.play + '</span>' +
        '<button type="button" class="sur-fs__btn sur-fs__close" data-sur-close aria-label="Close">' + ICON.close + '</button>' +
        '<button type="button" class="sur-fs__btn sur-fs__mute" data-sur-mute aria-label="Toggle sound">' + ICON.sound + '</button>' +
        '<button type="button" class="sur-fs__btn sur-fs__prev" data-sur-prev aria-label="Previous video">' + ICON.prev + '</button>' +
        '<button type="button" class="sur-fs__btn sur-fs__next" data-sur-next aria-label="Next video">' + ICON.next + '</button>' +
        '<div class="sur-fs__foot">' +
          '<div class="sur-fs__cap" data-sur-cap></div>' +
          '<div class="sur-fs__dots" data-sur-dots></div>' +
          '<div class="sur-fs__buy">' +
            '<div class="sur-fs__qty" data-sur-qty hidden>' +
              '<button type="button" data-sur-qty-minus aria-label="Decrease quantity">' + ICON.minus + '</button>' +
              '<span class="sur-fs__qty-count" data-sur-qty-count>1</span>' +
              '<button type="button" data-sur-qty-plus aria-label="Increase quantity">' + ICON.plus + '</button>' +
            '</div>' +
            '<button type="button" class="sur-fs__atc" data-sur-atc>Add to Cart</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(fs);
    video = fs.querySelector('[data-sur-video]');
    els = {
      paused: fs.querySelector('[data-sur-paused]'),
      mute: fs.querySelector('[data-sur-mute]'),
      prev: fs.querySelector('[data-sur-prev]'),
      next: fs.querySelector('[data-sur-next]'),
      cap: fs.querySelector('[data-sur-cap]'),
      dots: fs.querySelector('[data-sur-dots]'),
      atc: fs.querySelector('[data-sur-atc]'),
      qty: fs.querySelector('[data-sur-qty]'),
      qtyCount: fs.querySelector('[data-sur-qty-count]'),
      qtyMinus: fs.querySelector('[data-sur-qty-minus]'),
      qtyPlus: fs.querySelector('[data-sur-qty-plus]'),
    };
    /* the viewer's stepper just presses the page's main stepper buttons, so
       tier / pricing logic stays in the kit; the count is mirrored back */
    els.qtyMinus.addEventListener('click', () => { const b = document.querySelector('[data-s1-qty-minus]'); if (b) { b.click(); setTimeout(syncAtc, 30); } });
    els.qtyPlus.addEventListener('click', () => { const b = document.querySelector('[data-s1-qty-plus]'); if (b) { b.click(); setTimeout(syncAtc, 30); } });

    fs.querySelector('[data-sur-close]').addEventListener('click', close);
    els.prev.addEventListener('click', () => go(idx - 1));
    els.next.addEventListener('click', () => go(idx + 1));
    els.mute.addEventListener('click', () => { muted = !muted; video.muted = muted; renderMute(); });
    els.atc.addEventListener('click', onAtc);
    video.addEventListener('click', togglePlay);
    video.addEventListener('play', () => { els.paused.hidden = true; });
    video.addEventListener('pause', () => { els.paused.hidden = video.ended; });
    video.addEventListener('ended', () => { if (idx < items.length - 1) go(idx + 1); else { els.paused.hidden = false; } });
    video.addEventListener('timeupdate', () => {
      const d = els.dots.children[idx];
      if (d && video.duration) d.firstElementChild.style.width = ((video.currentTime / video.duration) * 100).toFixed(1) + '%';
    });

    /* swipe left / right between clips, swipe down to close */
    let sx = 0, sy = 0, st = 0;
    fs.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; st = Date.now(); }, { passive: true });
    fs.addEventListener('touchend', (e) => {
      const t = e.changedTouches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Date.now() - st > 600) return;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
    }, { passive: true });

    document.addEventListener('keydown', (e) => {
      if (fs.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
      else if (e.key === ' ') { e.preventDefault(); togglePlay(); }
    });
  }

  function renderMute() {
    els.mute.innerHTML = muted ? ICON.muted : ICON.sound;
    els.mute.setAttribute('aria-pressed', String(muted));
  }

  function togglePlay() {
    if (video.paused) video.play().catch(() => {});
    else video.pause();
  }

  function prefetch(i) {
    const it = items[i];
    if (!it || prefetched.has(it.src)) return;
    prefetched.add(it.src);
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'video';
    l.href = it.src;
    document.head.appendChild(l);
  }

  function go(i) {
    if (i < 0 || i >= items.length) return;
    idx = i;
    const it = items[idx];
    video.pause();
    video.muted = muted;
    video.poster = it.poster || '';
    video.src = it.src;
    video.load();
    const mySrc = it.src;
    video.play().catch(() => {
      if (video.src.indexOf(mySrc) === -1) return; /* superseded by a faster next/prev */
      /* browser refused sound: fall back to muted so the clip still plays */
      if (!muted) { muted = true; video.muted = true; renderMute(); video.play().catch(() => {}); }
    });
    els.cap.textContent = it.cap || '';
    els.prev.disabled = idx === 0;
    els.next.disabled = idx === items.length - 1;
    [...els.dots.children].forEach((d, k) => {
      d.classList.toggle('is-done', k < idx);
      d.firstElementChild.style.width = k < idx ? '100%' : '0%';
    });
    prefetch(idx + 1);
  }

  function syncAtc() {
    const m = mainBtn();
    if (!m) { els.atc.hidden = true; els.qty.hidden = true; return; }
    els.atc.hidden = false;
    const count = document.querySelector('[data-s1-qty-count]');
    const minus = document.querySelector('[data-s1-qty-minus]');
    const plus = document.querySelector('[data-s1-qty-plus]');
    els.qty.hidden = !count;
    if (count) {
      els.qtyCount.textContent = count.textContent.trim();
      els.qtyMinus.disabled = !!(minus && minus.disabled);
      els.qtyPlus.disabled = !!(plus && plus.disabled);
    }
    const label = m.querySelector('[data-s1-atc-label]');
    if (m.disabled) {
      els.atc.textContent = 'Select size';
      els.atc.setAttribute('data-sur-select', '');
    } else {
      els.atc.textContent = (label && label.textContent.trim()) || 'Add to Cart';
      els.atc.removeAttribute('data-sur-select');
    }
  }

  function onAtc() {
    const m = mainBtn();
    close();
    if (!m) return;
    if (m.disabled) {
      const sizes = document.querySelector('[data-s1-size-selector], [data-s1-size-scroll]');
      if (sizes) sizes.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    m.click();
  }

  function open(root, i) {
    build();
    items = [...root.querySelectorAll('[data-sur-tile]')].map((t) => ({
      src: t.dataset.surSrc, poster: t.dataset.surPoster || '', cap: t.dataset.surCap || '',
    }));
    if (!items.length) return;
    els.dots.innerHTML = items.map(() => '<span class="sur-fs__dot"><span></span></span>').join('');
    fs.hidden = false;
    document.documentElement.classList.add('sur-lock');
    /* one soundtrack at a time: pause every other playing video on the page */
    pausedOthers = [...document.querySelectorAll('video')].filter((v) => v !== video && !v.paused && !v.ended);
    pausedOthers.forEach((v) => { try { v.pause(); } catch (e) {} });
    renderMute();
    syncAtc();
    go(Math.min(Math.max(i, 0), items.length - 1));
  }

  function close() {
    if (!fs || fs.hidden) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    fs.hidden = true;
    document.documentElement.classList.remove('sur-lock');
    /* resume only silent background loops; anything with sound stays paused */
    pausedOthers.forEach((v) => { if (v.muted && document.contains(v)) v.play().catch(() => {}); });
    pausedOthers = [];
  }

  document.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-sur-tile]');
    if (!tile) return;
    e.preventDefault();
    const root = tile.closest('[data-sur]');
    const all = [...root.querySelectorAll('[data-sur-tile]')];
    open(root, all.indexOf(tile));
  });

  /* keep the viewer's button in step with the main one while it is open */
  document.addEventListener('s1:render', () => { if (fs && !fs.hidden) syncAtc(); });
  setInterval(() => { if (fs && !fs.hidden) syncAtc(); }, 800);
})();
